<template>
  <div>
    <b-row class="m-0">
      <b-col class="modal-hero">
        <b-card class="p-0 m-0 shadow-none">
          <b-row>
            <b-col class="pr-0 panel-divider panel-first">
              <div class="card-panel">
                <div class="stat-box-title">Patient</div>
                <div class="stat-box-body">
                  {{ t.firstName }} {{ t.lastName }}
                </div>
              </div>
            </b-col>
            <b-col class="pl-0 pr-0 panel-divider">
              <div class="card-panel">
                <div class="stat-box-title">Source</div>
                <div class="stat-box-body">{{ t.source | source }}</div>
              </div>
            </b-col>

            <b-col
              class="pl-0 pr-0 panel-divider col-md-auto"
              v-if="t.fundingSource == 'CHECK'"
            >
              <div class="card-panel text-left">
                <div style="float: left;">
                  <div class="stat-box-title pr-3">Payment Method</div>
                  <div class="stat-box-body">
                    Check
                  </div>
                </div>
                <div style="float: left;" class="fixed">
                  <img src="img/check.svg" height="40" /><br />
                </div>
              </div>
            </b-col>

            <b-col
              class="pl-0 pr-0 panel-divider col-md-auto"
              v-if="t.fundingSource == 'CASH'"
            >
              <div class="card-panel text-left">
                <div style="float: left;">
                  <div class="stat-box-title pr-3">Payment Method</div>
                  <div class="stat-box-body">
                    Cash
                  </div>
                </div>
                <div style="float: left;" class="fixed">
                  <img src="img/cash.svg" height="40" /><br />
                </div>
              </div>
            </b-col>

            <b-col
              class="pl-0 pr-0 panel-divider col-md-auto"
              v-if="t.fundingSource == 'CARD'"
            >
              <div class="card-panel text-right">
                <div class="stat-box-title">Card Number</div>
                <div class="stat-box-body">{{ t.cardDescription }}</div>
              </div>
            </b-col>
            <b-col
              class="pl-0 col-md-auto align-middle"
              v-if="t.fundingSource == 'CARD'"
            >
              <div class="card-panel text-right">
                <div style="float: left;">
                  <div class="stat-box-title">Exp Date</div>
                  <div class="stat-box-body">{{ expMonth }}/{{ expYear }}</div>
                </div>
                <div style="float: left;" class="fixed">
                  <card-svg-large height="40px" :cardType="t.cardType" /><br />
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="m-0">
      <b-col class="body-modal">
        <b-row>
          <b-col cols="1" class="mr-2">
            <div class="mt-1" style="position: relative; z-index: 999;">
              <i
                v-if="t.status.toUpperCase() == 'APPROVED'"
                v-b-tooltip.hover
                title="Approved"
                class="icomoon icon-status-approved text-success disposition"
              ></i>
              <i
                v-b-tooltip.hover
                title="Declined"
                v-if="t.status.toUpperCase() == 'DECLINED'"
                class="icomoon icon-status-declined text-danger disposition"
              ></i>
            </div>
          </b-col>
          <b-col>
            <div>
              <h3
                class="text-success"
                v-if="t.status.toUpperCase() == 'APPROVED'"
              >
                {{ t.status | title }}
              </h3>
              <h3
                class="text-danger"
                v-if="t.status.toUpperCase() == 'DECLINED'"
              >
                {{ t.status | title }}
              </h3>
              <div
                class="text-success mt--2"
                v-if="t.status.toUpperCase() == 'APPROVED'"
              >
                {{ (t.amount / 100) | currency }}
              </div>
              <div
                class="text-danger mt--2"
                v-if="t.status.toUpperCase() == 'DECLINED'"
              >
                {{ (t.amount / 100) | currency }}
              </div>
            </div>
            <b-row v-if="t.reason" class="mt-3">
              <b-col>
                <div class="light-alert light-alert-error mb-0">
                  <i class="fa-solid fa-triangle-exclamation"></i
                  ><b>Reason:</b> {{ t.reason }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <div class="form-control-label text-muted">
                  Transaction ID<br />
                </div>
                {{ t.referenceId.split("-")[0] }}
              </b-col>
              <b-col>
                <div class="form-control-label text-muted">Date<br /></div>
                {{ t.created | moment("MM/DD/YYYY") }}
              </b-col>
              <b-col>
                <div class="form-control-label text-muted">Time<br /></div>
                {{ t.created | moment("hh:mm:ss A") }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-5" v-if="t.refundVoidType">
          <b-col cols="1" class="align-middle text-center mt-1 mr-2">
            <i
              v-if="t.refundVoidType.toUpperCase() == 'REFUNDED'"
              v-b-tooltip.hover
              title="Refunded"
              class="icomoon icon-status-refunded text-warning disposition trans-icon"
            ></i>
            <i
              v-b-tooltip.hover
              title="Voided"
              v-if="t.refundVoidType.toUpperCase() == 'VOIDED'"
              class="icomoon icon-status-voided icon-void disposition trans-icon"
            ></i>
            <div class="unifier"><div class="unifier-pole"></div></div>
          </b-col>
          <b-col>
            <div>
              <h3
                :class="
                  t.refundVoidType == 'VOIDED' ? 'text-void' : 'text-warning'
                "
              >
                {{ t.refundVoidType | title }}
              </h3>
              <div
                :class="
                  (t.refundVoidType == 'VOIDED'
                    ? 'text-void'
                    : 'text-warning') + ' mt--2'
                "
              >
                {{ (t.refundVoidAmount / 100) | currency }}
              </div>
            </div>

            <b-row class="mt-3">
              <b-col>
                <div class="form-control-label text-muted">
                  Transaction ID<br />
                </div>
                {{ t.refundVoidReferenceId.split("-")[0] }}
              </b-col>
              <b-col>
                <div class="form-control-label text-muted">Date<br /></div>
                {{ t.refundVoidDate | moment("MM/DD/YYYY") }}
              </b-col>
              <b-col>
                <div class="form-control-label text-muted">Time<br /></div>
                {{ t.refundVoidDate | moment("hh:mm:ss A") }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CardSvgLarge from "@/views/Components/CardSvgLarge.vue";
import JsonViewer from "vue-json-viewer";

export default {
  name: "transaction",
  components: { CardSvgLarge, JsonViewer },
  props: { id: null },
  data() {
    return { t: null, expMonth: null, expYear: null };
  },
  async mounted() {
    var self = this;
    var r = await self.$client.get(
      "/api/transaction/transaction?id=" + this.id
    );
    this.t = r.data.value;
    var r = JSON.parse(this.t.resultMetaData);
    this.expMonth = r.fundingSource.card.expirationMonth;
    this.expYear = r.fundingSource.card.expirationYear;
  },
};
</script>

<style scoped>
.disposition {
  font-size: 2em !important;
}

.transactionPanelInside {
  padding: 2em;
}

.text-void {
  color: #adb5bd;
}

.unifier {
  position: absolute;
  width: 5px;
  height: 150px;
  top: -130px;
  left: 28px;
  z-index: 0;
}

.unifier-pole {
  background: #e9ecef;
  width: 5px;
  height: 132px;
  z-index: 0;
}

.trans-icon {
  z-index: 998;
  position: relative;
}

.fixed {
  width: 80px;
}
</style>
